var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftTeamsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.999,
    height: 52.092,
    viewBox: "0 0 55.999 52.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.174,
    y1: 1.067,
    x2: 0.826,
    y2: -0.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a62c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4d55bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940ab"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_Teams-Logo.wine",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14746",
    "data-name": "Path 14746",
    d: "M1504.462,777.5h14.465a2.474,2.474,0,0,1,2.474,2.474V793.15a9.094,9.094,0,0,1-9.094,9.094h-.043a9.094,9.094,0,0,1-9.1-9.093V778.793A1.293,1.293,0,0,1,1504.462,777.5Z",
    transform: "translate(-1465.402 -757.965)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3979",
    "data-name": "Ellipse 3979",
    cx: 5.86,
    cy: 5.86,
    r: 5.86,
    transform: "translate(42.976 5.209)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3980",
    "data-name": "Ellipse 3980",
    cx: 8.465,
    cy: 8.465,
    r: 8.465,
    transform: "translate(22.139 0)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14747",
    "data-name": "Path 14747",
    d: "M648.106,777.5H624.23a2.448,2.448,0,0,0-2.387,2.5v15.027a14.342,14.342,0,1,0,28.651,0V780a2.448,2.448,0,0,0-2.387-2.5Z",
    transform: "translate(-606.215 -757.965)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14748",
    "data-name": "Path 14748",
    d: "M637.6,777.5v21.058a2.4,2.4,0,0,1-1.485,2.2,2.309,2.309,0,0,1-.9.182h-12.1c-.169-.43-.326-.859-.456-1.3a15.859,15.859,0,0,1-.69-4.61V780a2.444,2.444,0,0,1,2.383-2.5Z",
    transform: "translate(-606.345 -757.965)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14749",
    "data-name": "Path 14749",
    d: "M636.3,777.5v22.361a2.306,2.306,0,0,1-.182.9,2.4,2.4,0,0,1-2.2,1.485H623.731c-.221-.43-.43-.859-.612-1.3a12.905,12.905,0,0,1-.456-1.3,15.859,15.859,0,0,1-.69-4.61V780a2.444,2.444,0,0,1,2.383-2.5Z",
    transform: "translate(-606.345 -757.965)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14750",
    "data-name": "Path 14750",
    d: "M636.3,777.5v19.756a2.4,2.4,0,0,1-2.383,2.383H622.664a15.861,15.861,0,0,1-.69-4.61V780a2.444,2.444,0,0,1,2.383-2.5Z",
    transform: "translate(-606.346 -757.965)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14751",
    "data-name": "Path 14751",
    d: "M635,777.5v19.756a2.4,2.4,0,0,1-2.383,2.383h-9.95a15.859,15.859,0,0,1-.69-4.61V780a2.444,2.444,0,0,1,2.383-2.5Z",
    transform: "translate(-606.346 -757.965)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14752",
    "data-name": "Path 14752",
    d: "M899.378,417.051v4.1c-.221.013-.43.026-.651.026s-.43-.013-.651-.026a7.149,7.149,0,0,1-1.3-.208,8.465,8.465,0,0,1-5.86-4.975,7.231,7.231,0,0,1-.417-1.3h6.5A2.392,2.392,0,0,1,899.378,417.051Z",
    transform: "translate(-868.122 -404.249)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14753",
    "data-name": "Path 14753",
    d: "M914.25,468.884v2.8a7.151,7.151,0,0,1-1.3-.208,8.465,8.465,0,0,1-5.86-4.975h4.779A2.392,2.392,0,0,1,914.25,468.884Z",
    transform: "translate(-884.297 -454.78)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14754",
    "data-name": "Path 14754",
    d: "M914.25,468.884v2.8a7.151,7.151,0,0,1-1.3-.208,8.465,8.465,0,0,1-5.86-4.975h4.779A2.392,2.392,0,0,1,914.25,468.884Z",
    transform: "translate(-884.297 -454.78)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14755",
    "data-name": "Path 14755",
    d: "M912.94,468.883v2.592a8.465,8.465,0,0,1-5.86-4.975h3.477A2.392,2.392,0,0,1,912.94,468.883Z",
    transform: "translate(-884.29 -454.779)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14756",
    "data-name": "Path 14756",
    d: "M2.387,466.5H26.264a2.387,2.387,0,0,1,2.387,2.387v23.877a2.387,2.387,0,0,1-2.387,2.387H2.387A2.387,2.387,0,0,1,0,492.764V468.887A2.387,2.387,0,0,1,2.387,466.5Z",
    transform: "translate(0 -454.779)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14757",
    "data-name": "Path 14757",
    d: "M332.688,730.365h-4.773v13h-3.041v-13h-4.751v-2.521h12.565Z",
    transform: "translate(-312.08 -709.557)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeamsLogo);
export default __webpack_public_path__ + "static/media/microsoft_teams-logo.81563da8c67f0ec5d3bea556ee8b1245.svg";
export { ForwardRef as ReactComponent };